import { Action, AnyAction, CombinedState, combineReducers, ThunkAction } from "@reduxjs/toolkit";
import { Reducer } from "react";
import reduxThunk from "redux-thunk";
import authMiddlewares from "../old/middlewares/authMiddlewares";
import rootReducer, { initialReducers } from "./rootReducer";
import { State } from "./Stores/ReduxStore";
import {createStore, applyMiddleware, compose} from "redux";

const selectedProject = localStorage.getItem("selected_project");
const selectedProjectObj = localStorage.getItem("selected_project_obj");

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const preloadedState: any = {
  auth: {
    authenticated: localStorage.getItem("access_token"),
    refreshToken: localStorage.getItem("refresh_token"),
    isAuth: localStorage.getItem("isAuth"),
    inProgress: false,
    isRefreshed: false,
  },
  project: {
    projects: [],
    open_projects: [],
    errorMessage: null,
    inProgress: true,
    totalItems: 0,
    filters: [],
    selectedProject: selectedProject
      ? parseInt(selectedProject)
      : selectedProject,
    selectedProjectObj: selectedProjectObj
      ? JSON.parse(selectedProjectObj)
      : selectedProjectObj,
  },
};

export const store = createStore(
  rootReducer,
  preloadedState,
  composeEnhancers(applyMiddleware(reduxThunk, authMiddlewares)),
);

const injectedReducers: any = {};
const injectReducer = (key: string, reducer?: Reducer<State, AnyAction>) => {
  if (!key || !reducer) {
    return;
  }
  injectedReducers[key] = reducer;

  const reducers: any = combineReducers({
    ...initialReducers,
    ...injectedReducers,
  });

  store.replaceReducer(reducers);
  
};
export { injectReducer };

export const getStateByName = (name: string) => {
  const state: CombinedState<any> = store.getState();
  
  if (Object.keys(state).includes(name)) {
    return state[name];
  }
}

export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
